import script from "./AppSwitchButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSwitchButton.vue?vue&type=script&setup=true&lang=js"

import "./AppSwitchButton.vue?vue&type=style&index=0&id=3c0b6393&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c0b6393"]])

export default __exports__